import { useEffect, useState } from 'react';
import { Collapse, Form, message,Modal, Typography,Pagination,Spin,Row,Col,Popconfirm,Input,DatePicker,Button } from 'antd';
import {  CloseCircleOutlined } from '@ant-design/icons';
import secureLocalStorage  from  "react-secure-storage";
import { CartonStatus,UserRole } from '../../enum';
import { AiFillEdit, AiOutlineSearch, AiOutlineSync ,AiOutlineRight,AiOutlineDown} from 'react-icons/ai';
import { Label } from 'reactstrap';
import { QueryDataModel ,Parameter ,Item, User,RequestChangeOwner} from '../../models'
import { Helper, InitHelper ,StickyHelper} from '../../helpers';
import { StorageCartonService ,HrWebService,ChangeOwnerService, PropertyService} from '../../services';
import { EmployeeAutoComplete } from '../../autocomplete/EmployeeAutoComplete'
import MessageCommon from '../../enum/Message';
import StorageCartonRequestDetail from '../StorageCarton/StorageCartonRequestDetail';
import { useNavigate } from 'react-router-dom';
import { OrgUnitAutoComplete } from '../../autocomplete/OrgUnitAutoComplete';
import { apiRequest } from "../../configurations/authConfig";
import { useMsal } from "@azure/msal-react";

interface AppState {
  currentPage:number
  perpage:number
  total: number
  items:QueryDataModel[]
  isLoading:boolean
}

const ChangeOwnerRequest = () => {
  const stickyHelper = new StickyHelper("change-owner",50,0)
  const stickyElement = stickyHelper.getElement()
    const { instance, accounts } = useMsal();
  const navigate = useNavigate();
  const userStore = secureLocalStorage.getItem('user')
  const user:User = userStore ? JSON.parse(userStore.toString()): null
  const pageSizeOptions = user.systemConfig.tablePageSize
  const [dataForm] = Form.useForm();
  const { Panel } = Collapse;
  const [isModalCartonOpen, setIsModalCartonOpen] = useState(false);
  const [recordNo, setRecordNo] = useState(0);
  const [messageApi] = message.useMessage();
  const [saveParameter,setSaveParameter] = useState<Parameter>(InitHelper.InitialParameter)
  const [appState,setAppState] = useState<AppState>({
    currentPage : 1,
    total : 0,
    perpage: 10,
    items: [],
    isLoading : true
  })
  const [requesters, setRequesters] = useState<Item[]>([])
  const [owners, setOwners] = useState<Item[]>([])
  const [newOwners, setNewOwners] = useState<Item[]>([])
  const [requestStartDate, setRequestStartDate] = useState<Date|null>(null);
  const [requestEndDate, setRequestEndDate] =  useState<Date|null>(null);
  const [orgunits, setOrgUnits] = useState<Item[]>([])
  const [clientHeight,setClientHeight] = useState(0)

  const onSetClientHeight = () => {
    
    setTimeout(() => {
      stickyHelper.updatePosition()
      window.scrollTo(0,0)
      let element = document.getElementById(stickyElement.container) as HTMLInputElement
      if(element){
        let value = element.clientHeight
        setClientHeight(value)
      }
    }, 100);
  
  }

  useEffect(() => {
    initial()

  }, [])

  const initial = () => {
    
    let parameter = Object.assign({},InitHelper.InitialParameter())
    parameter.condition = "or"
    parameter.requesters = [user.employeeId]
    parameter.owners = [user.employeeId]
    parameter.employeeLevel = 0
    getData(1,appState.perpage,parameter)
    stickyHelper.removeEvent()
    stickyHelper.addEvent()
    window.addEventListener("resize", () => { 
      onSetClientHeight()
  });
  }

  const handleEdit = (_recordNo:number) => {
    setRecordNo(_recordNo)
 }
  const onFinish = (values: any) => {
  };


  const validateMessages = {
    required: '${label} is required!',
    types: {
      email: '${label} is not a valid email!',
      number: '${label} is not a valid number!',
    },
    number: {
      range: '${label} must be between ${min} and ${max}',
    },
  };
  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };


  const getData = async (currentPage: number,perpage: number,_parameter:Parameter | null = null) => {
    let _state:AppState = Object.assign({},appState)
       _state.isLoading = true
       setAppState(_state)
    let parameter = Object.assign({},saveParameter)
    if(_parameter !== null){
        parameter = Object.assign({},_parameter);
    }
       
      parameter.page = currentPage
      parameter.limit = perpage
      parameter.statusIds = [CartonStatus.Done]
      parameter.userConfidential = user.employeeId
      parameter.requesterOrgUnit = user.orgUnit
      
      
      let token = await getToken()
      let result = await new StorageCartonService(token).SearchChangeOwner(parameter)
     
      if(result && result.success)
      {
    
        let state = Object.assign({},appState)
          state.total = result.data.total
          state.currentPage = currentPage
          state.perpage = perpage
          state.items = result.data.items
          state.isLoading = false
          state.perpage = perpage

        setTimeout(() => {
            setSaveParameter(parameter)
            setAppState(state)
            setTimeout(() => {
              onSetClientHeight()
            }, 100);
        }, 500);
      }
      else{
        let state = Object.assign({},appState)
        state.isLoading = false
        setTimeout(() => {
            setAppState(state)
          }, 500);
      }
      
  }

  const searchData = async () => {
    
    let field = dataForm.getFieldsValue()
   
    let parameter = InitHelper.InitialParameter();
        parameter.condition = 'and'
        if(field.requestNo)
        {
          parameter.requestNoList = field.requestNo.trim().split(",")
        }
       
    if(requestStartDate && requestEndDate){
        parameter.requestStartDate = requestStartDate
        parameter.requestEndDate = requestEndDate
    }

    if(requesters.length > 0){
      parameter.requesters = requesters.map(item => item.key)
    }

    if(owners.length > 0){
      parameter.owners = owners.map(item => item.key)
    }

    if(orgunits.length > 0){
        parameter.orgUnits = orgunits.map(item => item.key)
      }
    
    parameter.employeeLevel = user.level
    
    getData(1,appState.perpage,parameter).then(() => {
      stickyHelper.updatePosition(true)

    })
    
 }

 const onSearchEmployee = async(key:string) => {
   
    let token = await getToken()
    let result = await new HrWebService(token).SearchEmployee(key)
    if(result && result.success)
    {
        let _orgUnit = user.orgUnit
            if(user.orgUnit.indexOf("/") > -1) {
                _orgUnit = user.orgUnit.split("/")[0]
            }
            return result.data.filter(x => x.orgUnit && (x.orgUnit.trim().indexOf(_orgUnit.trim()) > -1))
    }
    else{
      console.log(result?.message)
      return []
    }
  }

 const onSearchEmployee2 = async(key:string) => {
   
  let token = await getToken()
  let result = await new HrWebService(token).SearchEmployee2(key)
  if(result && result.success)
  {
    let _orgUnit = user.orgUnit
            if(user.orgUnit.indexOf("/") > -1) {
                _orgUnit = user.orgUnit.split("/")[0]
            }
            return result.data.filter(x => x.orgUnit && (x.orgUnit.trim().indexOf(_orgUnit.trim()) > -1))
  }
  else{
    console.log(result?.message)
    return []
  }
}

    const getToken = async () => {
        const acc = accounts && accounts.length ? accounts[0] : null;
        apiRequest.scopes[0] = "api://" + secureLocalStorage.getItem('clientId') + "/read_user_profile"
        if (acc) {
            const { accessToken: token } = await instance.acquireTokenSilent({
                account: acc,
                scopes: apiRequest.scopes
            });
            return token;
        }
        return ""
    }


  const handleSave = async () => {
    if(newOwners.length === 0){
      return false
    }
    
      let requestChangeOwner: RequestChangeOwner = {
          recordNo: 0,
          recordNos: [],
        storageRecordNo: recordNo,
        requester:user.employeeId,
        onBehalfBy:"",
        newOwner: newOwners[0].key,
        statusId:CartonStatus.WaitAdmin
     }
      
      let token = await getToken()
      let result = await new ChangeOwnerService(token).CreateChangeOwner(requestChangeOwner);
      
      
      let element = document.getElementById(stickyElement.container) as HTMLElement
      if(result && result.success){
  
        messageApi.open({
          type: 'success',
          content: 'Save success',
          duration: 1,
          style: { marginTop: element.getBoundingClientRect().top , marginLeft: element.getBoundingClientRect().left  }
        });
        setTimeout(() => {
            navigate('/request-change-owner-2')
        
        }, 1000);
     }
      else{
        Modal.error({
            icon: <CloseCircleOutlined />,
            title: 'This is an error message',
            content: result?.message,
        });
      }
    
   
  };

  const cancelSave = () => {
    setRecordNo(0)
    setNewOwners([])
  }
  const onRequestStartDateChange = (date: any) => {
    setRequestStartDate(date);
  }

  const onRequestEndDateChange = (date: any) => {
    setRequestEndDate(date)
  }

  const onPageChange = (page:number,perpage:number) => {
    if(perpage !== appState.perpage){
        getData(1,perpage)
    }
    else{
      getData(page,appState.perpage)
    }
  }

  const onRequesterSelect = (item:any) => {
    setRequesters(item)
    stickyHelper.updatePosition()
  }

  const onOwnerSelect = (item:any) => {
    setOwners(item)
    stickyHelper.updatePosition()
  }

  const onOrgUnitSelect = (item:any) => {
    setOrgUnits(item)
    stickyHelper.updatePosition()
  }

  const onNewOwnerSelect = (item:any) => {
    setNewOwners(item)
  }

  const onSearchOrgUnit = async(key:string) => {
   
    let token = await getToken()
    let result = await new PropertyService(token).GetOrgUnits(key)
    if(result && result.success)
    {
      return result.data
    }
    else{
      console.log(result?.message)
      return []
    }
}
  const reset = () => {
   
    dataForm.resetFields()
    setRequesters([])
    setOwners([])
    setOrgUnits([])
    setRequestStartDate(null)
    setRequestEndDate(null)
    let parameter = Object.assign({},InitHelper.InitialParameter())
    parameter.condition = "or"
    parameter.requesters = [user.employeeId]
    parameter.owners = [user.employeeId]

    getData(1,appState.perpage,parameter)
  }

  const showModalCarton = async (_recordNo:number) => {
    setRecordNo(_recordNo)
    setIsModalCartonOpen(true);
  };

  const handleCancelCarton = () => {
    setRecordNo(0)
    setIsModalCartonOpen(false);
  };

  
  return (
    <div>
       <div id={stickyElement.search} className='carton-search-top' onClick={ () => stickyHelper.setCollapse()}>
          <span id="arrow-right" className='display-inline'>
              <AiOutlineRight className='carton-search-top-img'/>
          </span>
          <span id="arrow-down" className='display-none'>
            <AiOutlineDown  className='carton-search-top-img'/>
          </span>
          <span>Carton Search</span>
            
        </div>
        <div id={stickyElement.openSearch} className='carton-search-bottom' >
        <Form
            {...layout}
            form={dataForm}
            name="change-owner-form"
            onFinish={onFinish}
            validateMessages={validateMessages}
            labelAlign="left"
            colon={false}
            labelWrap={true}
          >
            <Row>
              <Col md={11} >
                <Form.Item name="owner" label="Owner"  >
                    <EmployeeAutoComplete
                            key={Helper.Uniqid()}
                            placeholder='Search by Name'
                            selectedItems={owners ? owners : []}
                            onChange={item => onOwnerSelect(item)}
                            service={onSearchEmployee2}
                            minimumTextLength={3}
                        />
                </Form.Item>
              </Col>
              <Col md={2} >
              </Col>
              <Col md={11} >
              <Form.Item name="requester" label="Requester"  >
                    <EmployeeAutoComplete
                            key={Helper.Uniqid()}
                            placeholder='Search by Name'
                            selectedItems={requesters ? requesters : []}
                            onChange={item => onRequesterSelect(item)}
                            service={onSearchEmployee2}
                            minimumTextLength={3}
                        />
                </Form.Item>
                
              </Col>
            </Row>
            <Row>
              <Col md={11} >
                <Form.Item name="orgUnit" label="Org. Unit"  >
                        <OrgUnitAutoComplete
                            key={Helper.Uniqid()}
                            placeholder='Search by Name'
                            selectedItems={orgunits ? orgunits : []}
                            onChange={item => onOrgUnitSelect(item)}
                            service={onSearchOrgUnit}
                            minimumTextLength={2}
                        />
                    </Form.Item>
              </Col>
              <Col md={2} >
              </Col>
              <Col md={11} >
                <Form.Item name="requestNo" label="Request No."  >
                  <Input placeholder="ex. A230001,B230002,B230004" />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col md={11} >
                <Form.Item name="requestDate" label="Request Date">
                      <table className='w100c'>
                        <tr>
                          <td>
                            <DatePicker placeholder={MessageCommon.TitleDate}  format={'DD MMM YYYY'} className='date-picker-full' onChange={onRequestStartDateChange}/>
                          </td>
                          <td>
                            <Label className='margin-left-10 margin-right-10'>To</Label>
                          </td>
                          <td>
                            <DatePicker placeholder={MessageCommon.TitleDate}  format={'DD MMM YYYY'} className='date-picker-full' onChange={onRequestEndDateChange}/>
                          </td>
                        </tr>
                      </table>
                </Form.Item>
              </Col>
              <Col md={2} >
              </Col>
              <Col md={11} >

              </Col>
            </Row>
           

          </Form>
          <div className='text-center'>
            <Button type="default" className='mr-btn'  onClick={reset}>
              <AiOutlineSync className='icn-btn' /> Reset
            </Button>
            <Button type="primary"  onClick={searchData} >
              <AiOutlineSearch className='icn-btn' /> Search
            </Button>
          </div>
        </div>

        <div id={stickyElement.space} className='sticky-space sticky-bg-white display-none'></div>
        <div id={stickyElement.space2} className='sticky-space2 sticky-bg-white'></div>

      <div id={stickyElement.result}  className='sticky-data-top sticky-border-top sticky-border-left sticky-border-right'>
            <div className='search-result'>Search found { appState.total } record(s).</div>
        </div>
      
    <div id={stickyElement.dataFixed} className='sticky-data-bottom sticky-border-bottom sticky-border-left sticky-border-right'>   
        <div id={stickyElement.container}>
        { appState.isLoading ?
            <div className='margin-auto padding-bottom-30'>
              <Spin tip="Loading" size="large">
                <div className="content" />
              </Spin>
            </div>
          :
          <table className='idoc-table'>
            <thead id={stickyElement.data}>
              <tr>
                <th className="s-th thfix1">Request No.</th>
                <th className="s-th">Org. Unit</th>
                <th className="s-th">Status</th>
                <th className="s-th">Current Owner</th>
                <th className="s-th">New Owner</th>
                <th className="s-th">Request Change Owner</th>
              </tr>
            </thead>
           
            <tbody >
            { appState.items.map((item:QueryDataModel) => (
                <tr>
                  <td className="s-td tdfix1 text-center"><a className='a-table'onClick={() => showModalCarton(item.recordNo)} >{item.requestNo}</a></td>
                  <td className="s-td text-center">{item.orgUnit}</td>
                  <td className="s-td text-center">{item.status}</td>
                  <td className="s-td text-center">{item.ownerName}</td>
                  <td className="s-td text-center">
                    { item.recordNo === recordNo? 
                      <EmployeeAutoComplete
                        key={Helper.Uniqid()}
                        placeholder='Search by Name'
                        selectedItems={newOwners ? newOwners : []}
                        onChange={item => onNewOwnerSelect(item)}
                        service={onSearchEmployee}
                        minimumTextLength={3}
                        pickOnlyOne
                      /> : <></> }
                  </td>
                  <td className="s-td text-center">
                    { item.recordNo === recordNo ?
                      <div>
                        <span>
                          <Popconfirm title="Confirm to update?" onConfirm={handleSave}>
                            <Typography.Link>Update</Typography.Link>
                          </Popconfirm>
                          <a className='margin-left-10' onClick={cancelSave}>
                            Cancel
                          </a>
                        </span>
                      </div>:
                      <AiFillEdit size={20} onClick={() => handleEdit(item.recordNo)} className='pointer'/>
                    }
                  </td>
                </tr>
              ))
            }
            
            </tbody>
  
          </table>
        }
        </div>
        <div className='margin-top-10 text-right'>
        { appState.total > 0 ?
            <Pagination 
                key={Helper.Uniqid()}
                current={appState.currentPage} 
                pageSize={appState.perpage}
                total={appState.total} 
                onChange={onPageChange} 
                pageSizeOptions={pageSizeOptions}
                showSizeChanger={true}
              />:<></>
        }
        </div>
    </div>
    
    <input type="hidden" id={stickyElement.clientHight} defaultValue={clientHeight}/>
    
    
      <Modal title="Request Detail" open={isModalCartonOpen} footer={''} width={1550} onCancel={handleCancelCarton}>
            <StorageCartonRequestDetail 
              key={Helper.Uniqid()}
                  recordNo={recordNo} cartonNumber={""}
              approveLevel={0}
            />
        </Modal>

     
    </div>
  );

}

export default ChangeOwnerRequest
